module.exports = __webpack_public_path__ + "static/img/share.3be0667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share.png
// module id = 7/E+
// module chunks = 1